module.exports = __webpack_public_path__ + "static/media/trend-even.2e7e3519.svg";